import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

import { P } from '@decisiv/ui-components/lib/components/Typography';

// The mockup calls for a taller VIN entry area (~100px) so several VINs are
// visible as they wrap. KDS TagInput's box defaults to a 50px min-height;
// raise it and top-align the content so tags fill from the top.
export const TagInputWrapper = styled.div`
  & > div > div > div:first-of-type {
    min-height: ${rem(100)};
    align-items: flex-start;
  }

  // KDS ContentCounter — the "100/100" text inside TagInput's <label>. KDS only
  // turns it red when the count exceeds maxTags, so force danger at the limit.
  // shortcut: matches KDS internal markup (label > span > span:last-child); no
  // test pins it, so a ui-components upgrade can break it silently — re-check.
  &.at-limit label > span > span:last-child {
    color: ${toColorString(color.status.danger.medium)};
  }
`;

export const WarningTitle = styled(P).attrs({
  as: 'span',
  weight: 'semibold',
})`
  flex: 1 1 auto;
`;

export const WarningAction = styled.span`
  flex: 0 0 auto;
`;

export const WarningMessage = styled.span`
  flex: 1 1 100%;
`;

export const WarningBody = styled.span`
  align-items: center;
  column-gap: ${rem(spacing.base)};
  display: flex;
  flex-wrap: wrap;

  @media (max-width: ${rem(650)}) {
    align-items: flex-start;
    flex-direction: column;
    row-gap: ${rem(spacing.base)};

    ${WarningTitle} {
      flex: 0 0 auto;
      order: 1;
    }

    ${WarningMessage} {
      flex: 0 0 auto;
      order: 2;
    }

    ${WarningAction} {
      order: 3;
    }
  }
`;
